"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentGroupMetrics = void 0;
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const __elasticsearch_1 = require("../../../__elasticsearch");
const __enums_1 = require("../../../__types/__enums");
const getAggregationQueryForGroup_1 = require("./getAggregationQueryForGroup");
const getShouldQueryForGroup_1 = require("./getShouldQueryForGroup");
const getZeroContentGroupMetrics = (groupId) => ({
    groupId,
    totalMembersCount: 0,
    staticMembersCount: 0,
    dynamicMembersCount: 0
});
function parseContentGroupMetricElasticsearchResult(groups, results) {
    const contentGroupMetrics = groups.map(group => {
        const groupId = group.id || group._id;
        const dynamicMembersBucketsBygroupId = keyBy_1.default(results.aggregations[groupId].dynamicMembers.buckets, (doc) => doc.key);
        const staticMembersBucketsBygroupId = keyBy_1.default(results.aggregations[groupId].staticMembers.buckets, (doc) => doc.key);
        const dynamicMembersBucket = dynamicMembersBucketsBygroupId[groupId];
        const staticMembersBucket = staticMembersBucketsBygroupId[groupId];
        const totalMembersBucket = results.aggregations[groupId].totalMembers;
        if (!dynamicMembersBucket && !staticMembersBucket) {
            return getZeroContentGroupMetrics(groupId);
        }
        return {
            groupId: group.id,
            totalMembersCount: (totalMembersBucket || {}).value || 0,
            staticMembersCount: (staticMembersBucket || {}).doc_count || 0,
            dynamicMembersCount: (dynamicMembersBucket || {}).doc_count || 0
        };
    });
    return contentGroupMetrics;
}
function getContentQueryForGroups(groups) {
    return {
        bool: {
            must: [
                {
                    term: {
                        deleted: {
                            value: false
                        }
                    }
                },
                {
                    term: {
                        isDraft: {
                            value: false
                        }
                    }
                },
                {
                    term: {
                        isUnpublished: {
                            value: false
                        }
                    }
                },
                {
                    bool: {
                        should: groups.map(getShouldQueryForGroup_1.getShouldQueryForGroup),
                        minimum_should_match: 1
                    }
                }
            ]
        }
    };
}
function getContentGroupMetrics(groups = []) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (groups.length === 0) {
            return [];
        }
        const contentQuery = getContentQueryForGroups(groups);
        const aggsQuery = getAggregationQueryForGroup_1.getAggregationQueryForGroup(groups);
        const metricsQuery = {
            query: contentQuery,
            aggs: aggsQuery
        };
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(__elasticsearch_1.ElasticsearchURLEnum.ES_AWS_URL);
        const elasticsearchResults = yield elasticsearchClient.search({
            index: __enums_1.ElasticsearchIndicesEnum.OFFERS,
            type: __enums_1.ElasticsearchTypesEnum.OFFER,
            size: 0,
            body: metricsQuery
        });
        return parseContentGroupMetricElasticsearchResult(groups, elasticsearchResults);
    });
}
exports.getContentGroupMetrics = getContentGroupMetrics;
//# sourceMappingURL=getContentGroupMetrics.js.map